export function getBlogMetaTags(yoast: any) {
  let newMetaTags: { key: string; value: string }[] = [];
  if (yoast.description !== undefined) {
    newMetaTags.push({ key: 'description', value: yoast.description });
  } else {
    newMetaTags.push({ key: 'description', value: yoast.og_description });
  }

  const metaRobots = `${yoast.robots.index}, ${yoast.robots.follow}, ${yoast.robots['max-snippet']}, ${yoast.robots['max-image-preview']}, ${yoast.robots['max-video-preview']}`;
  newMetaTags.push({ key: 'robots', value: metaRobots });
  newMetaTags.push({ key: 'UTF-8', value: '' });

  newMetaTags.push({ key: 'og:locale', value: yoast.og_locale });
  newMetaTags.push({ key: 'og:type', value: yoast.og_type });
  newMetaTags.push({ key: 'og:title', value: yoast.og_title });
  newMetaTags.push({ key: 'og:description', value: yoast.og_description });
  newMetaTags.push({ key: 'og:url', value: yoast.og_url });
  newMetaTags.push({ key: 'og:site_name', value: yoast.og_site_name });
  newMetaTags.push({ key: 'article:publisher', value: yoast.article_publisher });
  newMetaTags.push({ key: 'article:published_time', value: yoast.article_published_time });
  newMetaTags.push({ key: 'article:modified_time', value: yoast.article_modified_time });

  if (yoast.og_image !== undefined && yoast.og_image.length > 0) {
    newMetaTags.push({ key: 'og:image', value: yoast.og_image[0].url });
    newMetaTags.push({ key: 'og:image:width', value: yoast.og_image[0].width });
    newMetaTags.push({ key: 'og:image:height', value: yoast.og_image[0].height });
    newMetaTags.push({ key: 'og:image:type', value: yoast.og_image[0].type });
  }

  newMetaTags.push({ key: 'twitter:card', value: yoast.twitter_card });
  newMetaTags.push({
    key: 'twitter:creator',
    value: yoast.twitter_creator !== undefined ? yoast.twitter_creator : ''
  });
  newMetaTags.push({ key: 'twitter:site', value: yoast.twitter_site });

  if (yoast.twitter_misc !== undefined) {
    newMetaTags.push({ key: 'twitter:label1', value: 'Written by' });
    newMetaTags.push({ key: 'twitter:data1', value: yoast.twitter_misc['Written by'] });
    newMetaTags.push({ key: 'twitter:label2', value: 'Est. reading time' });
    newMetaTags.push({ key: 'twitter:data2', value: yoast.twitter_misc['Est. reading time'] });
  }

  return newMetaTags;
}
